import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function CollectionLoadingState() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        gap: 2,
      }}
    >
      <CircularProgress aria-label="Loading collections" sx={{ color: "var(--color-dark-dust)" }} />
      <Typography sx={{ fontSize: "14px", color: "#717171" }}>Loading collections…</Typography>
    </Box>
  );
}
